"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get castExcludeNullFields () {
        return castExcludeNullFields;
    },
    get getDottableKeys () {
        return getDottableKeys;
    },
    get isDevOrTest () {
        return isDevOrTest;
    },
    get isDevelopment () {
        return isDevelopment;
    },
    get isNotNil () {
        return isNotNil;
    },
    get isNotNull () {
        return isNotNull;
    },
    get isProduction () {
        return isProduction;
    },
    get isProductionOrStaging () {
        return isProductionOrStaging;
    },
    get isStaging () {
        return isStaging;
    },
    get isTest () {
        return isTest;
    },
    get sleep () {
        return sleep;
    }
});
const _lodash = require("lodash");
const _env = require("../env");
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
const sleep = (ms)=>_async_to_generator(function*() {
        return new Promise((resolve)=>setTimeout(resolve, ms));
    })();
function isNotNull(value) {
    return value !== null;
}
function isNotNil(value) {
    return !(0, _lodash.isNil)(value);
}
function castExcludeNullFields(input, _) {
    return input;
}
const getDottableKeys = (object, prefix = "")=>Object.keys(object).reduce((acc, key)=>{
        const dottedPrefix = prefix ? `${prefix}.` : "";
        if (typeof object[key] === "object" && object[key] !== null && !Array.isArray(object[key])) {
            return [
                ...acc,
                ...getDottableKeys(object[key], `${dottedPrefix}${key}`)
            ];
        } else {
            return [
                ...acc,
                `${dottedPrefix}${key}`
            ];
        }
    }, []);
function isStaging(env = _env.NODE_ENV) {
    return env === "staging";
}
function isProductionOrStaging(env = _env.NODE_ENV) {
    return isStaging(env) || isProduction(env);
}
function isProduction(env = _env.NODE_ENV) {
    return env === "production";
}
function isDevelopment(env = _env.NODE_ENV) {
    return env === "development";
}
function isTest(env = _env.NODE_ENV) {
    return env === "test";
}
function isDevOrTest(env = _env.NODE_ENV) {
    return isDevelopment(env) || isTest(env);
}

//# sourceMappingURL=data:application/json;base64,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